import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import PropTypes from 'prop-types';
import SuperLoggedInUser from './SuperLoggedInUser';

const SuperSidebar = ({setActivePage, onMenuSelect}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const path = location.pathname.replace('/', '') || '/';
    setActivePage(path);
  }, [location, setActivePage]);

  const getIcon = (path, icon, activeIcon) => {
    return location.pathname === path ? activeIcon : icon;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Mobile breakpoint
    };

    handleResize(); // Check on component mount
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div
      className={`bg-[#EDF1F1] ${
        isMobile ? 'h-[92%]' : 'h-full'
      } w-[250px] fixed font-customFont`}
    >
      <div className="flex items-center justify-start ms-3 mt-3">
        <img src="/logo.png" className="w-[40px]" alt="Logo" />
        <p className="text-black font-bold text-2xl ml-1">Expense</p>
      </div>

      <div className={`mt-2 ms-3 pb-2 ${isMobile ? 'me-3' : 'me-0'}`}>
        <div
          className={`flex items-center p-2 pl-2 cursor-pointer ${
            location.pathname === '/admin/dashboard'
              ? 'bg-white text-black rounded-md shadow-sm'
              : 'text-black'
          }`}
          onClick={() => {
            navigate('/admin/dashboard');
            if (onMenuSelect) onMenuSelect();
          }}
        >
          <img
            src={getIcon(
              '/admin/dashboard',
              '/icons/Dashboard.svg',
              '/icons/DashboardActive.svg'
            )}
            alt="Dashboard icon"
            className="mr-3 w-5 h-5"
          />
          <span className="flex-1">Dashboard</span>
        </div>

        <div
          className={`flex items-center p-2 pl-2 cursor-pointer ${
            location.pathname === '/admin/userList'
              ? 'bg-white text-black rounded-md shadow-sm'
              : 'text-black'
          }`}
          onClick={() => {
            navigate('/admin/userList');
            if (onMenuSelect) onMenuSelect();
          }}
        >
          <img
            src={getIcon(
              '/admin/userList',
              '/icons/Team.svg',
              '/icons/TeamActive.svg'
            )}
            alt="Team icon"
            className="mr-3 w-5 h-5"
          />
          <span className="flex-1">Users</span>
        </div>

        <div
          className={`flex items-center p-2 pl-2 cursor-pointer ${
            location.pathname === '/admin/notification'
              ? 'bg-white text-black rounded-md shadow-sm'
              : 'text-black'
          }`}
          onClick={() => {
            navigate('/admin/notification');
            if (onMenuSelect) onMenuSelect();
          }}
        >
          <i
            className={`mr-4 ml-1 ${
              location.pathname === '/admin/notification'
                ? 'fa-solid fa-bell text-[#535862]'
                : 'fa-regular fa-bell text-[#535862]'
            }`}
          ></i>
          <span className="flex-1">Notifications</span>
        </div>

        <div
          className={`flex items-center p-2 pl-2 cursor-pointer ${
            location.pathname === '/admin/packages'
              ? 'bg-white text-black rounded-md shadow-sm'
              : 'text-black'
          }`}
          onClick={() => {
            navigate('/admin/packages');
            if (onMenuSelect) onMenuSelect();
          }}
        >
          <i
            className={`mr-4 ml-1 ${
              location.pathname === '/admin/packages'
                ? 'fa-solid fa-folder text-[#535862]'
                : 'fa-regular fa-folder text-[#535862]'
            }`}
          ></i>
          <span className="flex-1">Packages</span>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full p-2 pl-3 flex items-center cursor-pointer text-gray-700">
        <SuperLoggedInUser onMenuSelect={onMenuSelect} />
      </div>
    </div>
  );
};

SuperSidebar.propTypes = {
  setActivePage: PropTypes.func.isRequired,
};

export default SuperSidebar;
